import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';

const AccordionMetadataComponent = (accordionDetails: {
  expanded: any;
  accordionInfo: any;
  data: any;
  handleToogleAccordion: any;
}) => {
  const { expanded, accordionInfo, data, handleToogleAccordion, ...other } = accordionDetails;
  return (
    <Accordion expanded={accordionInfo.position === expanded} onChange={handleToogleAccordion(accordionInfo.position)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
        <Typography sx={{ width: '60%', flexShrink: 0 }} className="acc-header">
          {accordionInfo.name}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableBody>
              {data.map((row: any) => (
                <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="right">{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default memo(AccordionMetadataComponent);
